export default {
  URL_DOSE_NOT_EXIST: "ادرس سایت وارد نشده است.",
  URL_INVALID: "ادرس سایت  نامعتبر است..",

  TYPE_ADVERTISE_DOSE_NOT_ENTER: "نوع تبلیغ وارد نشده است.",

  CATEGORIES_SITE_PUBLISHERS_DOSE_NOT_ENTER:
    "دسته سایت نمایش دهنده وارد نشده است.",
};
